// V182 — translation keys for V178 (Partner Widget), V179 (PulseAI Chatbot),
// V180 (Catalog Brain). Imported and merged into the main per-language
// dictionary in LanguageContext.
export const agentOsTranslations = {
  en: {
    // — V178 Partner Widget —
    sb_partner_widget: "Embed Widget",
    pw_program_live: "Partner program · LIVE",
    pw_title: "Embed Widget · Affiliate",
    pw_lead: "Drop a one-line <script> on your site — visitors see the live AI Autonomy ticker. Every click and unique visitor is attributed to you.",
    pw_revshare: "Revenue share",
    pw_per_unique: "per unique visitor / month",
    pw_your_id: "Your partner ID",
    pw_stat_total: "Total hits",
    pw_stat_24h: "Last 24h",
    pw_stat_unique: "Unique visitor-days",
    pw_stat_payout: "Estimated payout",
    pw_snippet_h: "Copy & paste on your site",
    pw_snippet_lead: "Drop this line before the closing </body> tag. The widget auto-loads and refreshes every 30s.",
    pw_copy: "Copy",
    pw_copied: "Copied",
    pw_open_window: "Open in new window",
    pw_refresh: "Refresh stats",
    pw_preview_h: "Live widget preview",
    pw_loading: "Loading…",
    pw_loaded: "Loaded",
    pw_tips_h: "Tips to maximise payout",
    pw_tip_1: "Place the widget above the fold or in your blog sidebar.",
    pw_tip_2: "Combine with an article about AI automation — visitors then click through naturally.",
    pw_tip_3: "Any visitor who becomes a paying customer generates a 20% recurring revenue share (via the ambassador program).",

    // — V179 Chatbot —
    cb_ask_pulseai: "Ask PulseAI",
    cb_open_chat: "Open AI chat",
    cb_close_chat: "Close chat",
    cb_subtitle: "Multilingual AI guide",
    cb_greeting_title: "Hi 👋",
    cb_greeting: "I'm PulseAI. Ask me about your agents, blog stats, or how to start a new automation.",
    cb_thinking: "PulseAI is typing…",
    cb_input_placeholder: "Type a message… (Enter to send)",
    cb_send: "Send",
    cb_error_generic: "Reply error.",
    // Admin toggle
    cb_admin_h: "Public landing chatbot",
    cb_admin_sub: "The dashboard chatbot is always on for logged-in users. Toggle this to also show the floating bubble on the public landing page.",
    cb_admin_on: "On",
    cb_admin_off: "Off",
    cb_admin_save_fail: "Save failed",

    // — V180 Catalog Brain —
    sb_catalog_brain: "Catalog Brain",
    cat_kicker: "Catalog Brain",
    cat_title: "E-shop Auto-sync",
    cat_lead: "AI reads your product catalog, suggests better SEO title, meta description and image alt — and pushes them back to your store with one click.",
    cat_no_stores_picker: "— No connected stores —",
    cat_no_stores_alert: "You have no connected store. First add one in Connected Stores.",
    cat_stat_products: "Products",
    cat_stat_pending: "Pending fixes",
    cat_stat_applied: "Applied",
    cat_stat_last_pull: "Last pull",
    cat_btn_pull: "Pull catalog",
    cat_btn_analyse: "Run AI analysis (Claude)",
    cat_filter_label: "Show:",
    cat_filter_pending: "pending",
    cat_filter_applied: "applied",
    cat_filter_skipped: "skipped",
    cat_filter_failed: "failed",
    cat_proposals: "AI proposals",
    cat_select_all: "Select all",
    cat_bulk_apply: "Apply selected",
    cat_no_fixes_pre: "No proposals in status",
    cat_no_fixes_post: ". Run the AI analysis above.",
    cat_diff_title: "SEO title",
    cat_diff_meta: "Meta description",
    cat_diff_alt: "Image alt",
    cat_diff_current: "Current",
    cat_diff_new: "New (AI)",
    cat_why: "Why",
    cat_apply: "Apply",
    cat_skip: "Skip",
    cat_tag_applied: "Applied",
    cat_tag_failed: "Failed",
    cat_tag_skipped: "Skipped",
    cat_t_pulled: "Pulled {n} products",
    cat_t_pull_fail: "Pull failed",
    cat_t_analyse: "AI proposals: +{ok} · OK skipped: {skipped} · failed: {failed}",
    cat_t_analyse_fail: "Analysis failed",
    cat_t_applied: "Applied",
    cat_t_apply_fail: "Apply failed",
    cat_t_bulk: "Applied: {ok} · Failed: {failed}",
    cat_t_bulk_fail: "Bulk apply failed",
    cat_t_select_some: "Select at least one proposal",
    cat_t_load_fail: "Failed to load",
  },

  sk: {
    sb_partner_widget: "Embed Widget",
    pw_program_live: "Partner program · LIVE",
    pw_title: "Embed Widget · Affiliate",
    pw_lead: "Vlož na svoj web jednoriadkový <script> a návštevníci uvidia live AI Autonomy ticker. Každý klik a unikátny návštevník je pripísaný tebe.",
    pw_revshare: "Revenue share",
    pw_per_unique: "za unikátneho návštevníka / mesiac",
    pw_your_id: "Tvoj partner ID",
    pw_stat_total: "Total hits",
    pw_stat_24h: "Posledných 24h",
    pw_stat_unique: "Unique visitor-days",
    pw_stat_payout: "Odhadovaný payout",
    pw_snippet_h: "Skopíruj a vlož na svoj web",
    pw_snippet_lead: "Vlož tento riadok pred koniec </body> tagu. Widget sa automaticky načíta a každých 30s sa obnoví.",
    pw_copy: "Kopírovať",
    pw_copied: "Skopírované",
    pw_open_window: "Otvoriť v novom okne",
    pw_refresh: "Obnoviť štatistiky",
    pw_preview_h: "Live náhľad widgetu",
    pw_loading: "Načítavam…",
    pw_loaded: "Načítané",
    pw_tips_h: "Tipy pre maximálny payout",
    pw_tip_1: "Umiestni widget nad fold alebo do bočného sidebaru blogu.",
    pw_tip_2: "Skombinuj s článkom o AI automatizácii — visitor sa potom prirodzene preklikne.",
    pw_tip_3: "Návštevník, ktorý sa stane platiacim klientom, ti generuje 20% recurring revenue share (cez ambassador program).",

    cb_ask_pulseai: "Spýtaj sa PulseAI",
    cb_open_chat: "Otvoriť AI chat",
    cb_close_chat: "Zavrieť chat",
    cb_subtitle: "Viacjazyčný AI sprievodca",
    cb_greeting_title: "Ahoj 👋",
    cb_greeting: "Som PulseAI. Pýtaj sa ma na tvojich agentov, blog štatistiky, alebo ako spustiť novú automatizáciu.",
    cb_thinking: "PulseAI píše…",
    cb_input_placeholder: "Napíš správu… (Enter pošle)",
    cb_send: "Poslať",
    cb_error_generic: "Chyba pri odpovedi.",
    cb_admin_h: "Verejný chatbot na landing page",
    cb_admin_sub: "Dashboard chatbot je vždy zapnutý pre prihlásených používateľov. Tu nastavíš, či sa má floating bubble zobraziť aj na verejnej landing page.",
    cb_admin_on: "Zapnutý",
    cb_admin_off: "Vypnutý",
    cb_admin_save_fail: "Uloženie zlyhalo",

    sb_catalog_brain: "Catalog Brain",
    cat_kicker: "Catalog Brain",
    cat_title: "E-shop Auto-sync",
    cat_lead: "AI prečíta tvoj katalog produktov, navrhne lepšie SEO title, meta description a image alt — a jedným klikom ich pošle naspäť do tvojho e-shopu.",
    cat_no_stores_picker: "— Žiadne pripojené e-shopy —",
    cat_no_stores_alert: "Nemáš pripojený žiadny e-shop. Najprv pridaj store v Connected Stores.",
    cat_stat_products: "Produkty",
    cat_stat_pending: "Pending fixes",
    cat_stat_applied: "Aplikované",
    cat_stat_last_pull: "Posledný pull",
    cat_btn_pull: "Stiahnuť katalog",
    cat_btn_analyse: "Spustiť AI analýzu (Claude)",
    cat_filter_label: "Zobraziť:",
    cat_filter_pending: "pending",
    cat_filter_applied: "applied",
    cat_filter_skipped: "skipped",
    cat_filter_failed: "failed",
    cat_proposals: "AI návrhy",
    cat_select_all: "Vybrať všetko",
    cat_bulk_apply: "Aplikovať vybrané",
    cat_no_fixes_pre: "Žiadne návrhy v stave",
    cat_no_fixes_post: ". Spusti AI analýzu vyššie.",
    cat_diff_title: "SEO title",
    cat_diff_meta: "Meta description",
    cat_diff_alt: "Image alt",
    cat_diff_current: "Pôvodné",
    cat_diff_new: "Nové (AI)",
    cat_why: "Prečo",
    cat_apply: "Aplikovať",
    cat_skip: "Preskočiť",
    cat_tag_applied: "Aplikované",
    cat_tag_failed: "Zlyhalo",
    cat_tag_skipped: "Preskočené",
    cat_t_pulled: "Stiahnutých {n} produktov",
    cat_t_pull_fail: "Pull zlyhal",
    cat_t_analyse: "AI návrhy: +{ok} · OK preskočené: {skipped} · zlyhalo: {failed}",
    cat_t_analyse_fail: "Analýza zlyhala",
    cat_t_applied: "Aplikované",
    cat_t_apply_fail: "Apply zlyhal",
    cat_t_bulk: "Aplikované: {ok} · zlyhané: {failed}",
    cat_t_bulk_fail: "Hromadný apply zlyhal",
    cat_t_select_some: "Vyber aspoň jeden návrh",
    cat_t_load_fail: "Nepodarilo sa načítať",
  },

  cs: {
    sb_partner_widget: "Embed Widget",
    pw_program_live: "Partner program · LIVE",
    pw_title: "Embed Widget · Affiliate",
    pw_lead: "Vlož na svůj web jednořádkový <script> a návštěvníci uvidí live AI Autonomy ticker. Každý klik a unikátní návštěvník je připsán tobě.",
    pw_revshare: "Revenue share",
    pw_per_unique: "za unikátního návštěvníka / měsíc",
    pw_your_id: "Tvoje partner ID",
    pw_stat_total: "Total hits",
    pw_stat_24h: "Posledních 24h",
    pw_stat_unique: "Unique visitor-days",
    pw_stat_payout: "Odhadovaný payout",
    pw_snippet_h: "Zkopíruj a vlož na svůj web",
    pw_snippet_lead: "Vlož tento řádek před konec </body> tagu. Widget se automaticky načte a každých 30s se obnoví.",
    pw_copy: "Kopírovat",
    pw_copied: "Zkopírováno",
    pw_open_window: "Otevřít v novém okně",
    pw_refresh: "Obnovit statistiky",
    pw_preview_h: "Live náhled widgetu",
    pw_loading: "Načítám…",
    pw_loaded: "Načteno",
    pw_tips_h: "Tipy pro maximální payout",
    pw_tip_1: "Umísti widget nad fold nebo do bočního sidebaru blogu.",
    pw_tip_2: "Zkombinuj s článkem o AI automatizaci — visitor se pak přirozeně proklikne.",
    pw_tip_3: "Návštěvník, který se stane platícím klientem, ti generuje 20% recurring revenue share (přes ambassador program).",

    cb_ask_pulseai: "Zeptat se PulseAI",
    cb_open_chat: "Otevřít AI chat",
    cb_close_chat: "Zavřít chat",
    cb_subtitle: "Vícejazyčný AI průvodce",
    cb_greeting_title: "Ahoj 👋",
    cb_greeting: "Jsem PulseAI. Ptej se mě na tvé agenty, blog statistiky, nebo jak spustit novou automatizaci.",
    cb_thinking: "PulseAI píše…",
    cb_input_placeholder: "Napiš zprávu… (Enter odešle)",
    cb_send: "Odeslat",
    cb_error_generic: "Chyba při odpovědi.",
    cb_admin_h: "Veřejný chatbot na landing page",
    cb_admin_sub: "Dashboard chatbot je vždy zapnutý pro přihlášené uživatele. Tady nastavíš, jestli se má floating bubble zobrazit i na veřejné landing page.",
    cb_admin_on: "Zapnutý",
    cb_admin_off: "Vypnutý",
    cb_admin_save_fail: "Uložení selhalo",

    sb_catalog_brain: "Catalog Brain",
    cat_kicker: "Catalog Brain",
    cat_title: "E-shop Auto-sync",
    cat_lead: "AI přečte tvůj katalog produktů, navrhne lepší SEO title, meta description a image alt — a jedním klikem je pošle zpět do tvého e-shopu.",
    cat_no_stores_picker: "— Žádné připojené e-shopy —",
    cat_no_stores_alert: "Nemáš připojený žádný e-shop. Nejprve přidej store v Connected Stores.",
    cat_stat_products: "Produkty",
    cat_stat_pending: "Pending fixes",
    cat_stat_applied: "Aplikované",
    cat_stat_last_pull: "Poslední pull",
    cat_btn_pull: "Stáhnout katalog",
    cat_btn_analyse: "Spustit AI analýzu (Claude)",
    cat_filter_label: "Zobrazit:",
    cat_filter_pending: "pending",
    cat_filter_applied: "applied",
    cat_filter_skipped: "skipped",
    cat_filter_failed: "failed",
    cat_proposals: "AI návrhy",
    cat_select_all: "Vybrat vše",
    cat_bulk_apply: "Aplikovat vybrané",
    cat_no_fixes_pre: "Žádné návrhy ve stavu",
    cat_no_fixes_post: ". Spusť AI analýzu nahoře.",
    cat_diff_title: "SEO title",
    cat_diff_meta: "Meta description",
    cat_diff_alt: "Image alt",
    cat_diff_current: "Původní",
    cat_diff_new: "Nové (AI)",
    cat_why: "Proč",
    cat_apply: "Aplikovat",
    cat_skip: "Přeskočit",
    cat_tag_applied: "Aplikováno",
    cat_tag_failed: "Selhalo",
    cat_tag_skipped: "Přeskočeno",
    cat_t_pulled: "Staženo {n} produktů",
    cat_t_pull_fail: "Pull selhal",
    cat_t_analyse: "AI návrhy: +{ok} · OK přeskočeno: {skipped} · selhalo: {failed}",
    cat_t_analyse_fail: "Analýza selhala",
    cat_t_applied: "Aplikováno",
    cat_t_apply_fail: "Apply selhal",
    cat_t_bulk: "Aplikováno: {ok} · selhané: {failed}",
    cat_t_bulk_fail: "Hromadný apply selhal",
    cat_t_select_some: "Vyber alespoň jeden návrh",
    cat_t_load_fail: "Nepodařilo se načíst",
  },

  de: {
    sb_partner_widget: "Embed-Widget",
    pw_program_live: "Partnerprogramm · LIVE",
    pw_title: "Embed-Widget · Affiliate",
    pw_lead: "Füge eine einzeilige <script>-Zeile auf deiner Website ein — Besucher sehen den Live-AI-Autonomy-Ticker. Jeder Klick und einzigartige Besucher wird dir zugeordnet.",
    pw_revshare: "Umsatzbeteiligung",
    pw_per_unique: "pro einzigartigem Besucher / Monat",
    pw_your_id: "Deine Partner-ID",
    pw_stat_total: "Gesamt-Hits",
    pw_stat_24h: "Letzte 24h",
    pw_stat_unique: "Einzigartige Besuchertage",
    pw_stat_payout: "Geschätzte Auszahlung",
    pw_snippet_h: "Kopieren & auf deiner Website einfügen",
    pw_snippet_lead: "Füge diese Zeile vor dem schließenden </body>-Tag ein. Das Widget lädt automatisch und aktualisiert alle 30s.",
    pw_copy: "Kopieren",
    pw_copied: "Kopiert",
    pw_open_window: "In neuem Fenster öffnen",
    pw_refresh: "Statistiken aktualisieren",
    pw_preview_h: "Live-Widget-Vorschau",
    pw_loading: "Lädt…",
    pw_loaded: "Geladen",
    pw_tips_h: "Tipps für maximale Auszahlung",
    pw_tip_1: "Platziere das Widget über dem Fold oder in der Sidebar deines Blogs.",
    pw_tip_2: "Kombiniere mit einem Artikel über KI-Automatisierung — Besucher klicken dann natürlich durch.",
    pw_tip_3: "Jeder Besucher, der zum zahlenden Kunden wird, generiert eine wiederkehrende 20%-Umsatzbeteiligung (über das Ambassador-Programm).",

    cb_ask_pulseai: "PulseAI fragen",
    cb_open_chat: "AI-Chat öffnen",
    cb_close_chat: "Chat schließen",
    cb_subtitle: "Mehrsprachiger AI-Guide",
    cb_greeting_title: "Hallo 👋",
    cb_greeting: "Ich bin PulseAI. Frag mich nach deinen Agents, Blog-Statistiken oder wie du eine neue Automatisierung startest.",
    cb_thinking: "PulseAI tippt…",
    cb_input_placeholder: "Nachricht eingeben… (Enter zum Senden)",
    cb_send: "Senden",
    cb_error_generic: "Antwortfehler.",
    cb_admin_h: "Öffentlicher Landing-Chatbot",
    cb_admin_sub: "Der Dashboard-Chatbot ist für eingeloggte Nutzer immer an. Hier legst du fest, ob die schwebende Bubble auch auf der öffentlichen Landing-Page erscheinen soll.",
    cb_admin_on: "An",
    cb_admin_off: "Aus",
    cb_admin_save_fail: "Speichern fehlgeschlagen",

    sb_catalog_brain: "Catalog Brain",
    cat_kicker: "Catalog Brain",
    cat_title: "Shop Auto-Sync",
    cat_lead: "Die KI liest deinen Produktkatalog, schlägt bessere SEO-Title, Meta-Description und Bild-Alt vor — und überträgt sie mit einem Klick zurück in deinen Shop.",
    cat_no_stores_picker: "— Keine verbundenen Shops —",
    cat_no_stores_alert: "Du hast keinen verbundenen Shop. Füge zuerst einen in Connected Stores hinzu.",
    cat_stat_products: "Produkte",
    cat_stat_pending: "Offene Fixes",
    cat_stat_applied: "Angewendet",
    cat_stat_last_pull: "Letzter Pull",
    cat_btn_pull: "Katalog laden",
    cat_btn_analyse: "KI-Analyse starten (Claude)",
    cat_filter_label: "Anzeigen:",
    cat_filter_pending: "offen",
    cat_filter_applied: "angewendet",
    cat_filter_skipped: "übersprungen",
    cat_filter_failed: "fehlgeschlagen",
    cat_proposals: "KI-Vorschläge",
    cat_select_all: "Alle auswählen",
    cat_bulk_apply: "Ausgewählte anwenden",
    cat_no_fixes_pre: "Keine Vorschläge im Status",
    cat_no_fixes_post: ". Starte oben die KI-Analyse.",
    cat_diff_title: "SEO-Title",
    cat_diff_meta: "Meta-Description",
    cat_diff_alt: "Bild-Alt",
    cat_diff_current: "Aktuell",
    cat_diff_new: "Neu (KI)",
    cat_why: "Warum",
    cat_apply: "Anwenden",
    cat_skip: "Überspringen",
    cat_tag_applied: "Angewendet",
    cat_tag_failed: "Fehlgeschlagen",
    cat_tag_skipped: "Übersprungen",
    cat_t_pulled: "{n} Produkte geladen",
    cat_t_pull_fail: "Pull fehlgeschlagen",
    cat_t_analyse: "KI-Vorschläge: +{ok} · OK übersprungen: {skipped} · fehlgeschlagen: {failed}",
    cat_t_analyse_fail: "Analyse fehlgeschlagen",
    cat_t_applied: "Angewendet",
    cat_t_apply_fail: "Anwendung fehlgeschlagen",
    cat_t_bulk: "Angewendet: {ok} · Fehlgeschlagen: {failed}",
    cat_t_bulk_fail: "Bulk-Anwendung fehlgeschlagen",
    cat_t_select_some: "Wähle mindestens einen Vorschlag",
    cat_t_load_fail: "Laden fehlgeschlagen",
  },
};
